export enum EMainMenuBadge {
	APP_NEW = 'app-new',
	APP_HIT = 'app-hit',
	APP_NOTIFY = 'app-notify',
	COUNTER = 'counter',
}
